/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SearchUnitsByEanInput = {
  ean: string;
};

export type ResolveEanToSkusQueryVariables = Exact<{
  input: Types.SearchUnitsByEanInput;
}>;

export type ResolveEanToSkusQuery = { searchUnitsByEan: { units: Array<{ productSku: string }> } };

export const ResolveEanToSkusDocument = gql`
  query resolveEanToSkus($input: SearchUnitsByEanInput!) {
    searchUnitsByEan(searchUnitsByEanInput: $input) {
      units {
        productSku
      }
    }
  }
`;

/**
 * __useResolveEanToSkusQuery__
 *
 * To run a query within a React component, call `useResolveEanToSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveEanToSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveEanToSkusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveEanToSkusQuery(
  baseOptions: Apollo.QueryHookOptions<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables> &
    ({ variables: ResolveEanToSkusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>(
    ResolveEanToSkusDocument,
    options,
  );
}
export function useResolveEanToSkusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>(
    ResolveEanToSkusDocument,
    options,
  );
}
// @ts-ignore
export function useResolveEanToSkusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ResolveEanToSkusQuery,
    ResolveEanToSkusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>;
export function useResolveEanToSkusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>,
): Apollo.UseSuspenseQueryResult<ResolveEanToSkusQuery | undefined, ResolveEanToSkusQueryVariables>;
export function useResolveEanToSkusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ResolveEanToSkusQuery, ResolveEanToSkusQueryVariables>(
    ResolveEanToSkusDocument,
    options,
  );
}
export type ResolveEanToSkusQueryHookResult = ReturnType<typeof useResolveEanToSkusQuery>;
export type ResolveEanToSkusLazyQueryHookResult = ReturnType<typeof useResolveEanToSkusLazyQuery>;
export type ResolveEanToSkusSuspenseQueryHookResult = ReturnType<
  typeof useResolveEanToSkusSuspenseQuery
>;
export type ResolveEanToSkusQueryResult = Apollo.QueryResult<
  ResolveEanToSkusQuery,
  ResolveEanToSkusQueryVariables
>;
